import React from 'react';
import {
  ApiBlueprint,
  configApiRef,
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { oktaTokenApiRef } from '@eng-portal/czi-extensions-react';
import { AgentRegistryClient, agentRegistryApiRef } from './api';
import { AgentRegistryPageMount } from './components/AgentRegistryPageMount';
import { MockAgentRegistryClient } from './mocks';
import { agentRouteRef, profileRouteRef, rootRouteRef } from './routes';

const agentRegistryApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: agentRegistryApiRef,
      deps: {
        configApi: configApiRef,
        oktaTokenApi: oktaTokenApiRef,
      },
      factory: ({ configApi, oktaTokenApi }) => {
        if (configApi.getOptionalBoolean('app.e2eTestMode')) {
          return new MockAgentRegistryClient();
        }
        return new AgentRegistryClient(configApi, oktaTokenApi);
      },
    }),
});

const profilesPage = PageBlueprint.make({
  params: {
    path: '/agent-registry',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ProfilesPage').then(module => (
        <AgentRegistryPageMount>
          <module.ProfilesPage />
        </AgentRegistryPageMount>
      )),
  },
});

const profilePage = PageBlueprint.make({
  name: 'profile',
  params: {
    path: '/agent-registry/profiles/:profileName',
    routeRef: profileRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ProfileOverviewPage').then(module => (
        <AgentRegistryPageMount>
          <module.ProfileOverviewPage />
        </AgentRegistryPageMount>
      )),
  },
});

const agentPage = PageBlueprint.make({
  name: 'agent',
  params: {
    path: '/agent-registry/profiles/:profileName/agents/:agentName',
    routeRef: agentRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AgentDetailPage').then(module => (
        <AgentRegistryPageMount>
          <module.AgentDetailPage />
        </AgentRegistryPageMount>
      )),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'agent-registry',
  extensions: [agentRegistryApi, profilesPage, profilePage, agentPage],
  routes: {
    root: rootRouteRef,
    profile: profileRouteRef,
    agent: agentRouteRef,
  },
});

export default plugin;
